import {
  SidebarValueMui as SidebarValue,
  SidebarValueWrapperMui as SidebarValueWrapper,
  useDisplayNames,
} from '@spotify/confidence-core-react';
import { MetricsV1FilterInput } from '@spotify/confidence-graphql';

import { MetricFilterPreview } from '../MetricFilters';

type InputsSummaryProps = {
  value: {
    entity?: string | null;
    factTable?: string | null;
    filter?: Maybe<MetricsV1FilterInput>;
  };
};

export const InputsSummary = ({ value }: InputsSummaryProps) => {
  const { displayNames } = useDisplayNames();

  return (
    <SidebarValueWrapper>
      <SidebarValue
        name="Fact table"
        value={displayNames.get(value.factTable || '') || value.factTable}
      />
      <SidebarValue
        name="Entity"
        value={displayNames.get(value.entity || '') || value.entity}
      />
      {value.filter && (
        <SidebarValue
          name="Filter"
          value={<MetricFilterPreview filter={value.filter} />}
        />
      )}
    </SidebarValueWrapper>
  );
};
